export const en = {
  // Common
  common: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    close: 'Close',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    apply: 'Apply',
    reset: 'Reset',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    first: 'First',
    last: 'Last',
    today: 'Today',
    export: 'Export',
    import: 'Import',
    download: 'Download',
    upload: 'Upload',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand',
    collapse: 'Collapse',
    show: 'Show',
    hide: 'Hide',
    settings: 'Settings',
    language: 'Language',
    colleague: 'Colleague',
    year: 'Year',
    site: 'Site',
    saving: 'Saving...',
    deleting: 'Deleting...',
    startDate: 'Start Date',
    endDate: 'End Date',
    legend: 'Legend'
  },

  // Authentication
  auth: {
    signIn: 'Sign in',
    signOut: 'Sign out',
    signUp: 'Sign up',
    email: 'Email address',
    password: 'Password',
    site: 'Site',
    firstName: 'First Name',
    lastName: 'Last Name',
    mobile: 'Mobile',
    signInToAccount: 'Sign in to your account',
    invalidCredentials: 'Invalid credentials',
    registrationFailed: 'Registration failed',
    loginFailed: 'Login failed',
    signingIn: 'Signing in...',
    loginRequired: 'You must be logged in to request holidays',
    authenticationRequired: 'You must be logged in to access this feature',
    loginSection: 'My Calendar',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordChanged: 'Password changed successfully',
    passwordChangeFailed: 'Failed to change password',
    passwordsDontMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    passwordMinLength: 'At least 8 characters',
    passwordUppercase: 'One uppercase letter',
    passwordNumber: 'One number',
    passwordSpecialChar: 'One special character',
    passwordMatch: 'Passwords match',
    passwordsRequired: 'Current and new passwords are required',
    incorrectPassword: 'Current password is incorrect',
    userNotFound: 'User not found',
    mustChangePassword: 'Change Your Password',
    mustChangePasswordMessage: 'For security reasons, you must change your password before continuing.',
    emailRequired: 'Email is required',
    passwordRequired: 'Password is required',
    siteRequired: 'Site is required',
  },

  // Calendar
  calendar: {
    calendar: 'Calendar',
    teamCalendar: 'Team Calendar',
    goToToday: 'Go to today',
    toggleSettingsPanel: 'Toggle settings panel',
    settings: 'Settings',
    previousWeek: 'Previous week',
    nextWeek: 'Next week',
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    previousYear: 'Previous year',
    nextYear: 'Next year',
    openMonthPicker: 'Open month picker',
    closeMonthPicker: 'Close month picker',
    weekNumber: 'Week {{number}}',
    addEvent: 'Add Event',
    editEvent: 'Edit Event',
    eventDetails: 'Event Details',
    deleteEvent: 'Delete Event',
    createHoliday: 'Click to create holiday for week {{week}} ({{startDate}} - {{endDate}})',
    deleteHoliday: 'Click to delete holiday for week {{week}} ({{startDate}} - {{endDate}})',
    available: 'Available',
    unavailable: 'Unavailable',
    weekend: 'Weekend',
    holiday: 'Holiday',
    requestedLeave: 'Requested Holiday',
    approvedHoliday: 'Approved Holiday',
    deniedHoliday: 'Denied Holiday',
    pendingHoliday: 'Pending Holiday',
    requestedDesiderata: 'Requested Desiderata',
    requestedPeriod: 'Period Request',
    eventCreated: 'Event created successfully',
    eventUpdated: 'Event updated successfully',
    eventDeleted: 'Event deleted successfully',
    failedToCreateEvent: 'Failed to create event',
    failedToUpdateEvent: 'Failed to update event',
    failedToDeleteEvent: 'Failed to delete event',
    dateNotAvailable: 'Date not available',
    onDuty: 'On Duty',
    noOnDutyStaff: 'No on-duty staff assigned',
    showMobile: 'Show mobile number',
  },

  // Events
  events: {
    title: 'Title',
    description: 'Description',
    date: 'Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    type: 'Type',
    status: 'Status',
    pending: 'Pending',
    approved: 'Approved',
    denied: 'Denied',
    duration: 'Duration: {{days}} days',
    untitledEvent: 'Untitled Event',
    noDescription: 'No description',
    enterTitle: 'Enter {{type}} title',
    enterDescription: 'Enter {{type}} description',
    eventType: 'Event Type',
    periodStatus: 'Period Status',
    holidayRequestsOpen: 'Holiday requests are open ({{period}})',
    holidayDesiderataOpen: 'Holiday and Desiderata requests are open ({{period}})',
    periodClosed: 'Period is closed for requests ({{period}})',
    unknownStatus: 'Unknown status ({{period}})',
    noEventTypesAvailable: 'No Event Types Available',
    periodClosedMessage: 'This date is in a closed period. Event creation is not allowed.',
    cascadedSystem: 'Cascaded system: Holiday requests have priority over Desiderata',
    saving: 'Saving...',
    deleting: 'Deleting...',
    changesSaved: 'Changes saved successfully',
    failedToSave: 'Failed to save changes',
    modifyDates: 'Modify Dates',
    extendPeriod: 'Extend to Include Weekends',
    dateModificationNote: 'Changes will be applied immediately upon saving.',
    confirmDelete: 'Confirm Deletion',
    deleteWarning: 'This action cannot be undone.',
    createForColleague: 'Create Event for Colleague',
    selectAtLeastOneTimeSlot: 'Please select at least one time slot',
    editDetails: 'Edit Title & Description',
    changeStatus: 'Change Status',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusDenied: 'Denied',
    statusChanged: 'Status changed successfully',
    statusChangeNote: 'Changing status requires admin privileges.',
    eventNotFound: 'Event not found',
    notAuthorizedToModifyEvent: 'You are not authorized to modify this event',
    cannotModifyApprovedEventDates: 'Cannot modify dates or status of approved events. Only title and description can be edited.',
    editApprovedEvent: 'Edit Approved Event',
    editApprovedEventWarning: 'This event has been approved. You can only modify the title and description. Changes will need to be reviewed.',
    proceedToEdit: 'Proceed to Edit',
    onlyAdminsCanChangeStatus: 'Only administrators can change event status',
  },

  // Users
  users: {
    userManagement: 'User Management',
    addUser: 'Add User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    role: 'Role',
    status: 'Status',
    admin: 'Admin',
    user: 'User',
    active: 'Active',
    inactive: 'Inactive',
    actions: 'Actions',
    searchUsers: 'Search users...',
    allRoles: 'All Roles',
    allStatus: 'All Status',
    deleteConfirmation: 'Are you sure you want to delete {{name}}? This action cannot be undone.',
    cannotDeleteLastAdmin: 'Cannot delete the last admin user',
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
    failedToCreateUser: 'Failed to create user',
    failedToUpdateUser: 'Failed to update user',
    failedToDeleteUser: 'Failed to delete user',
    passwordRequirements: 'Password must be at least 8 characters and contain at least one uppercase letter, one number, and one special character',
    leaveBlankToKeep: '(leave blank to keep current)',
    page: 'Page {{current}} of {{total}}',
    unknownUser: 'Unknown User',
    selectColleague: 'Select Colleague Name',
  },

  // Settings
  settings: {
    settings: 'Settings',
    colleagues: 'Colleagues',
    admin: 'Admin',
    display: 'Display',
    manageUsers: 'Manage Users',
    manageColleagueDisplay: 'Manage Colleague Display',
    subscribeToCalendar: 'Subscribe to Calendar',
    exportEvents: 'Export Events',
    definePeriods: 'Define/Edit Periods',
    exportAllData: 'Export All Data (ZIP)',
    reports: 'Reports',
    weekStartsOn: 'Week starts on:',
    showWeekNumber: 'Show week number:',
    showWeekends: 'Show weekends',
    showWerklijsten: 'Show work lists (programma)',
    showColleagueHolidayRequests: 'Show colleague holiday requests',
    left: 'Left',
    right: 'Right',
    none: 'None',
    colleagueDisplaySettings: 'Colleague Display Settings',
    abbreviation: 'Abbreviation',
    color: 'Color',
    hideColleague: 'Hide colleague',
    showColleague: 'Show colleague',
    editInitials: 'Edit initials',
    clickToEditInitials: 'Click to edit initials',
    failedToUpdateSettings: 'Failed to update settings',
    orderUpdated: 'Colleague order updated successfully',
    failedToUpdateOrder: 'Failed to update colleague order',
  },

  // Availability
  availability: {
    setAvailability: 'Availability',
    setAvailabilityFor: 'Availability for {{firstname}} {{lastname}}',
    weeklySchedule: 'Weekly Schedule',
    evenWeeks: 'Even Weeks',
    oddWeeks: 'Odd Weeks',
    everyWeek: 'Every Week',
    alternateWeeks: 'Alternate Weeks',
    repeatPattern: 'Repeat Pattern',
    addScheduleBefore: 'Add schedule before',
    addScheduleAfter: 'Add schedule after',
    splitSchedule: 'Split schedule',
    deleteSchedule: 'Delete schedule',
    extendPrecedingSchedule: 'Extend preceding schedule',
    extendFollowingSchedule: 'Extend following schedule',
    firstSchedule: 'First schedule',
    previousSchedule: 'Previous schedule',
    nextSchedule: 'Next schedule',
    lastSchedule: 'Last schedule',
    newSchedule: 'New',
    addNewSchedule: 'Add New Schedule',
    splitDate: 'Split Date',
    endDateForCurrentSchedule: 'End Date for Current Schedule',
    newScheduleWillStart: 'The new schedule will start on {{date}}',
    selectDateBetween: 'Select a date between {{start}} and {{end}} to split the schedule.',
    availabilityReport: 'Availability Report',
    availabilityReportFor: 'Availability Report for {{name}} - {{year}}',
    viewReport: 'View Report',
    viewCalendarReport: 'Calendar Report',
    clickToToggle: 'Click on time slots to toggle individual updates. Changes are saved automatically.',
    availabilityUpdated: 'Availability updated',
    failedToUpdateAvailability: 'Failed to update availability',
    morning: 'Morning',
    afternoon: 'Afternoon',
    am: 'AM',
    pm: 'PM',
    toggleAvailability: 'Toggle {{day}} {{period}} availability',
    timeSlots: 'Time Slots',
    reportLoaded: 'Report loaded successfully',
    failedToCreateSchedule: 'Failed to create schedule',
    failedToUpdateSchedule: 'Failed to update schedule',
    failedToDeleteSchedule: 'Failed to delete schedule',
  },

  // Export
  export: {
    exportEvents: 'Export Events',
    exportType: 'Export Type',
    allEvents: 'All Events',
    myEventsOnly: 'My Events Only',
    startDateOptional: 'Start Date (Optional)',
    endDateOptional: 'End Date (Optional)',
    leaveDatesEmpty: 'Leave dates empty to export all events. If you specify a date range, only events within that range will be exported.',
    exporting: 'Exporting...',
    preparingExport: 'Preparing your export file...',
    exportDownloaded: 'Export file downloaded successfully!',
    failedToExport: 'Failed to export events. Please try again.',
  },

  // Subscription
  subscription: {
    calendarSubscription: 'Calendar Subscription',
    subscribeToYourCalendar: 'Subscribe to Your Calendar',
    subscriptionInstructions: 'Use this URL to subscribe to your calendar in your preferred calendar application:',
    copyUrl: 'Copy URL',
    instructionsFor: 'Instructions for {{app}}',
    outlook: 'Microsoft Outlook',
    googleCalendar: 'Google Calendar',
    appleCalendar: 'Apple Calendar',
    otherApplications: 'Other Applications',
    outlookInstructions: [
      'Open Outlook Desktop or Outlook Web',
      'Right-click on Calendar in the navigation pane',
      'Select "Add Calendar" → "From Internet"',
      'Paste the subscription URL',
      'Click "OK" or "Save"',
      'Choose how often you want Outlook to sync the calendar',
      'Click "Yes" to add the calendar'
    ],
    googleInstructions: [
      'Open Google Calendar in your browser',
      'On the left side, find "Other calendars" and click the "+" button',
      'Select "From URL" from the dropdown menu',
      'Paste the subscription URL in the "URL" field',
      'Click "Add calendar"',
      'The calendar will appear under "Other calendars" in your calendar list'
    ],
    appleInstructions: [
      'Open the Calendar app on your Mac',
      'From the menu bar, select File',
      'Choose "New Calendar Subscription"',
      'Paste the subscription URL',
      'Click "Subscribe"',
      'Configure sync frequency and other options as needed',
      'Click "OK" to finish'
    ],
    appleIosInstructions: [
      'Go to Settings → Calendar → Accounts',
      'Tap "Add Account" → "Other" → "Add Subscribed Calendar"',
      'Paste the subscription URL',
      'Tap "Next" and then "Save"'
    ],
    otherInstructions: [
      'Look for an option to add a calendar subscription or "Subscribe to Calendar"',
      'When prompted, paste the subscription URL provided above',
      'Configure sync frequency if the option is available',
      'Save or confirm the subscription'
    ],
    icalNote: 'Note: The calendar uses the iCalendar (.ics) format, which is compatible with most modern calendar applications.',
    failedToFetchUrl: 'Failed to fetch subscription URL',
  },

  // Periods
  periods: {
    periodManagement: 'Period Management',
    addPeriod: 'Add Period',
    editPeriod: 'Edit Period',
    deletePeriod: 'Delete Period',
    resetToDefaults: 'Reset to Defaults',
    saveChanges: 'Save Changes',
    nameLabel: 'Name/Label',
    editingStatus: 'Editing Status',
    closed: 'Closed',
    openHoliday: 'Open - Holiday',
    openDesiderata: 'Open - Desiderata',
    defaultClosed: 'Default: Closed',
    enterPeriodName: 'Enter period name',
    updatePeriod: 'Update Period',
    noPeriodsForYear: 'No periods defined for {{year}}. Click "Add Period" to get started.',
    resetConfirmation: 'Are you sure you want to reset to default periods? This will overwrite all current periods.',
    periodsSaved: 'Periods saved successfully',
    periodsReset: 'Periods reset to defaults',
    failedToSavePeriods: 'Failed to save periods',
    failedToResetPeriods: 'Failed to reset periods',
    failedToLoadPeriods: 'Failed to load periods',
    colleagueOrder: 'Colleague Order',
    dragToReorder: 'Drag to reorder ({{count}} colleagues)',
    noColleaguesAvailable: 'No colleagues available',
    manageColleagueOrder: 'Manage Colleague Order',
    validationErrors: {
      nameRequired: 'Name is required',
      startDateRequired: 'Start date is required',
      endDateRequired: 'End date is required',
      endDateAfterStart: 'End date must be after start date',
      overlappingDates: 'Period dates overlap with existing period',
      periodsOverlap: 'Periods "{{period1}}" and "{{period2}}" have overlapping dates',
    },
  },

  // Connection Status
  connection: {
    connected: 'Connected to real-time updates',
    disconnected: 'Disconnected from real-time updates',
    lostConnection: 'Lost connection to real-time updates',
    reconnecting: 'Attempting to reconnect...',
  },

  // Notifications
  notifications: {
    eventCreatedByColleague: 'Event {{action}} by colleague',
    colleagueUpdatedAvailability: 'Colleague updated their availability',
    userConnected: 'User connected',
    userDisconnected: 'User disconnected',
    requestApproved: 'Request approved successfully',
    requestDenied: 'Request denied successfully',
    failedToApprove: 'Failed to approve request',
    failedToDeny: 'Failed to deny request',
    updatedEvents: 'Updated {{count}} events',
    failedToUpdateEvents: 'Failed to update events',
  },

  // Admin Holiday Modal
  adminHoliday: {
    requestManagement: 'Request Management',
    adminReview: 'Admin Review',
    employeeInformation: 'Employee Information',
    currentStatus: 'Current Status',
    requestType: 'Request Type',
    dateRange: 'Date Range',
    requestDetails: 'Request Details',
    submissionInfo: 'Submitted on {{date}}',
    lastUpdated: 'Last updated on {{date}}',
    approveRequest: 'Approve Request',
    denyRequest: 'Deny Request',
    processing: 'Processing...',
    clickToManage: 'Click to manage {{name}}\'s request',
    clickToViewDetails: 'Click to view details',
  },

  // Desiderata
  desiderata: {
    desiderataDays: 'Desiderata',
    workingDays: 'Working Days',
    weekendDays: 'Weekend Days',
    remaining: 'Remaining',
    priority: 'Priority',
    limitExceeded: 'Selection limit exceeded',
    approachingLimit: 'Approaching selection limit',
    totalAvailable: 'Total Available',
    publicHolidays: 'Public Holidays',
    mandatoryExtension: 'Selection extended due to mandatory weekend rules',
    autoExtendedToWeekend: 'Selection automatically extended to include weekend',
  },

  // Version Display
  version: {
    systemInformation: 'System Information',
    frontend: 'Frontend',
    backend: 'Backend',
    version: 'Version:',
    buildDate: 'Build Date:',
    environment: 'Environment:',
    targetUrl: 'Target URL:',
    status: 'Status:',
    uptime: 'Uptime:',
    lastCheck: 'Last Check:',
    refreshHealthCheck: 'Refresh Health Check',
    checking: 'Checking...',
    production: 'production',
    development: 'development',
    healthy: 'healthy',
    error: 'Error',
  },

  // Days of the week (short)
  days: {
    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
  },

  // Months
  months: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
  },

  // Error messages
  errors: {
    somethingWentWrong: 'Something went wrong',
    failedToLoadData: 'Failed to load data',
    networkError: 'Network error',
    unauthorized: 'Unauthorized',
    forbidden: 'Forbidden',
    notFound: 'Not found',
    internalServerError: 'Internal server error',
    validationError: 'Validation error',
    unknownError: 'Unknown error',
  },

  // Public holidays
  publicHolidays: {
    newYearsDay: 'New Year\'s Day',
    easterSunday: 'Easter Sunday',
    easterMonday: 'Easter Monday',
    labourDay: 'Labour Day',
    ascensionDay: 'Ascension Day',
    whitSunday: 'Whit Sunday',
    whitMonday: 'Whit Monday',
    belgianNationalDay: 'Belgian National Day',
    assumptionDay: 'Assumption Day',
    allSaintsDay: 'All Saints\' Day',
    armisticeDay: 'Armistice Day',
    christmasDay: 'Christmas Day',
    goodFriday: 'Good Friday',
    earlyMayBankHoliday: 'Early May Bank Holiday',
    springBankHoliday: 'Spring Bank Holiday',
    summerBankHoliday: 'Summer Bank Holiday',
    boxingDay: 'Boxing Day',
  },

  // Documents
  documents: {
    downloadSchedule: 'Download on-duty schedule (PDF)',
    downloadFailed: 'Download failed. Please try again.',
    invalidFileType: 'Invalid file type. Only PDF files are allowed.',
    invalidFilename: 'Invalid filename.',
    fileNotFound: 'Document not found.',
    failedToDownload: 'Failed to download document.',
    failedToListDocuments: 'Failed to list documents.',
  },

  // Reports
  reports: {
    desiderata: 'Desiderata',
    desiderataReport: 'Desiderata Report',
    desiderataReportDescription: 'Export desiderata data to Excel',
    desiderataReportInstructions: 'Select a year and period to generate an Excel report showing desiderata requests across all team members.',
    availability: 'Availability',
    availabilityReport: 'Availability Report',
    availabilityReportDescription: 'Export team availability schedules to Excel',
    availabilityReportInstructions: 'Generate an Excel report showing work schedules and availability for all team members.',
    aggregatedAvailability: 'Aggregated Availability',
    aggregatedAvailabilityDescription: 'Export unavailable team members by date',
    aggregatedAvailabilityInstructions: 'Generate an Excel report showing which team members are unavailable for each date/period.',
    unavailableUsers: 'Unavailable Users',
    aggregatedLeave: 'Aggregated Leave',
    aggregatedLeaveDescription: 'Export team members on leave by date',
    aggregatedLeaveInstructions: 'Generate an Excel report showing which team members are on leave for each date/period.',
    usersOnLeave: 'Users on Leave',
    period: 'Period',
    date: 'Date',
    total: 'Total',
    selectPeriod: 'Please select a period',
    noDataAvailable: 'No data available for the selected period',
    noPeriodsAvailable: 'No periods available',
    exporting: 'Exporting...',
    exportToExcel: 'Export to Excel',
    exportSuccess: 'Report exported successfully',
    exportFailed: 'Failed to export report. Please try again.',
  },
};